import React from "react";
import Footer from "./Footer.js";

export function Privacy() {
    return (
        <>
            <div id="main">
            <div id="home-container">
            <h2>Privacy Policy</h2>
            <div id="home-animation">
            <div className="legal-container">
                <h3>1. Introduction</h3>
                <p>Lit Pro is a service provided by Nexus Stone Solutions ("we," "our," "us"). At Nexus Stone Solutions, your privacy is important to us. This Privacy Policy outlines how we collect, use, and protect your personal information when you use our web application. By using our services, you agree to the collection and use of information in accordance with this policy.</p>
                <h3>2. Information We Collect</h3>
                <p>We may collect the following types of information:</p>
                <ul>
                <li>Personal Information
                <ul>
                    <li> - Name, email address, and password when you create an account.</li>
                    <li> - Payment details processed through our third-party payment processor, Stripe.</li>
                </ul>
                </li>
                <li>Uploaded Files
                <ul>
                    <li> - Documents you upload to our web application for the literature review service.</li>
                </ul>
                </li>
                <li>Usage Data
                <ul>
                    <li> - Information about your interactions with our web application, including IP address, browser type, and operating system.</li>
                </ul>
                </li>
                </ul>
                <h3>3. How We Use Your Information</h3>
                <p>We use the information we collect to:</p>
                <ul>
                <li>Provide and improve our services.</li>
                <li>Process payments and deliver literature reviews.</li>
                <li>Respond to your inquiries and support requests.</li>
                <li>Monitor and enhance the security of our web application.</li>
                </ul>
                <h3>4. Sharing Your Information</h3>
                <p>We do not sell your personal information. We may share your personal information with third parties as necessary to provide our services, including:</p>
                <ul>
                <li>Payment processing by Stripe.</li>
                <li>Compliance with legal obligations or law enforcement requests.</li>
                </ul>
                <h3>5. Data Retention</h3>
                <p>We retain your information for as long as necessary to provide our services, comply with legal obligations, or resolve disputes. Uploaded files are stored for the duration required to complete the literature review service and are deleted within 90 days.</p>
                <h3>6. Security of Your Information</h3>
                <p>We implement industry-standard measures to protect your personal information from unauthorized access, alteration, or disclosure. However, no method of transmission or storage is completely secure, and we cannot guarantee absolute security.</p>
                <h3>7. Your Rights</h3>
                <p>Depending on your location, you may have the following rights regarding your personal information:</p>
                <ul>
                <li>Access and obtain a copy of your personal data.</li>
                <li>Request corrections to your data if it is inaccurate or incomplete.</li>
                <li>Request deletion of your data, subject to legal and operational limitations.</li>
                <li>Withdraw consent for data processing where applicable.</li>
                </ul>
                <p>To exercise these rights, contact us at legal@nexusstone.cloud.</p>
                <h3>8. Cookies and Tracking Technologies</h3>
                <p>Our web application may use cookies and similar technologies to enhance your user experience. You can manage cookie preferences through your browser settings.</p>
                <h3>9. Third-Party Services</h3>
                <p>Our web application integrates third-party services, such as Stripe for payment processing. These third parties have their own privacy policies, and we encourage you to review them.</p>
                <h3>10. Changes to This Privacy Policy</h3>
                <p>We may update this Privacy Policy from time to time. Changes will be effective upon posting to our web application. Your continued use of our services constitutes acceptance of the updated policy.</p>
                <h3>11. Contact Us</h3>
                <p>If you have questions or concerns about this Privacy Policy, please contact us at legal@nexusstone.cloud.</p>
            </div>
            <div className="divider-h"></div>
            </div>
            </div>
            </div>
            <Footer />
        </>
    )
}

export function Terms() {
    return (
        <>
            <div id="main">
            <div id="home-container">
            <h2>Terms and Conditions</h2>
            <div id="home-animation">
            <div className="legal-container">
                <h3>1. Introduction</h3>
                <p>Lit Pro is a service provided by Nexus Stone Solutions ("we," "our," "us"). These Terms and Conditions ("Terms") govern your use of our web application, including creating a user account, purchasing services, uploading files, and receiving literature reviews. By accessing or using our web application, you agree to be bound by these Terms. If you do not agree with these Terms, you must not use our web application.</p>
                <h3>2. Eligibility</h3>
                <p>To use our web application, you must:</p>
                <ul>
                <li>Be at least 18 years old or the age of majority in your jurisdiction.</li>
                <li>Provide accurate and complete information during account registration.</li>
                <li>Use our services in compliance with all applicable laws and regulations.</li>
                </ul>
                <h3>3. Account Creation</h3>
                <p>You must create an account using a valid email address and a secure password to access our services. You are responsible for maintaining the confidentiality of your account credentials and are liable for any activity under your account. Notify us immediately of unauthorized access or use of your account.</p>
                <h3>4. Service Purchase</h3>
                <p>We use Stripe to process payments securely. By purchasing a literature review service, you agree to:</p>
                <ul>
                <li>Provide accurate payment information.</li>
                <li>Authorize us to charge your selected payment method for the service fee.</li>
                <li>Acknowledge that all sales are final and non-refundable unless explicitly stated otherwise.</li>
                </ul>
                <h3>5. User Content and File Uploads</h3>
                <p>By uploading files to our web application, you represent and warrant that:</p>
                <ul>
                <li>You have the necessary rights or permissions to upload the files.</li>
                <li>The files do not contain malicious software, illegal content, or violate third-party rights.</li>
                <li>We do not claim ownership of your uploaded files. However, you grant us a non-exclusive, worldwide, royalty-free license to process and analyze the files solely for providing the literature review service.</li>
                </ul>
                <h3>6. Delivery of Literature Reviews</h3>
                <p>We strive to deliver high-quality literature reviews promptly. However, we do not guarantee specific delivery times and are not responsible for delays caused by factors outside our control. Literature reviews are provided for informational purposes only and should not be considered professional or academic advice.</p>
                <h3>7. Prohibited Activities</h3>
                <p>You agree not to:</p>
                <ul>
                <li>Use our web application for unlawful or fraudulent purposes.</li>
                <li>Interfere with or disrupt the functionality of our web application.</li>
                <li>Attempt to reverse-engineer or gain unauthorized access to our systems.</li>
                </ul>
                <h3>8. Intellectual Property</h3>
                <p>All content, software, and materials provided on our web application are owned by us or our licensors and are protected by intellectual property laws. You may not copy, modify, distribute, or exploit our intellectual property without prior written consent.</p>
                <h3>9. Disclaimer of Warranties</h3>
                <p>Our web application is provided "as is" and "as available." We make no representations or warranties of any kind, express or implied, regarding the accuracy, reliability, or availability of our services. Your use of the web application is at your sole risk.</p>
                <h3>10. Limitation of Liability</h3>
                <p>To the fullest extent permitted by law, we are not liable for any direct, indirect, incidental, special, consequential, or punitive damages arising from your use of our web application or services.</p>
                <h3>11. Indemnification</h3>
                <p>You agree to indemnify and hold us harmless from any claims, losses, liabilities, or expenses arising from your breach of these Terms or your misuse of our web application.</p>
                <h3>12. Modifications to the Terms</h3>
                <p>We reserve the right to update or modify these Terms at any time. Changes will be effective immediately upon posting on our web application. Your continued use of the web application constitutes acceptance of the revised Terms.</p>
                <h3>13. Termination</h3>
                <p>We may suspend or terminate your access to our web application for any reason, including your violation of these Terms. Upon termination, your right to use our services will cease immediately.</p>
                <h3>14. Governing Law</h3>
                <p>These Terms are governed by and construed in accordance with the laws of the United States of America, without regard to its conflict of laws principles.</p>
                <h3>15. Data Processing Agreement (DPA)</h3>
                <p>For users who engage with our platform under the scope of applicable data protection laws (e.g., GDPR), we process uploaded files and personal data solely for the purpose of delivering our services. Uploaded files are temporarily stored, processed, and deleted in compliance with our Privacy Policy. By using our services, you consent to this data processing arrangement.</p>
                <h3>16. Digital Millennium Copyright Act (DMCA)</h3>
                <p>If you believe that any content uploaded to our platform infringes upon your copyright, you may submit a DMCA takedown request. Such requests must include:</p>
                <ul>
                <li>A description of the copyrighted material you claim has been infringed.</li>
                <li>The URL or location of the infringing material on our platform.</li>
                <li>Your contact information, including email and phone number.</li>
                <li>A statement under penalty of perjury that you have a good faith belief that the material is not authorized by the copyright owner, agent, or law.</li>
                </ul>
                <p>Send DMCA requests to support@nexusstone.cloud. We reserve the right to remove content and terminate accounts in response to valid takedown requests.</p>
                <h3>17. Accessibility Policy</h3>
                <p>We are committed to ensuring that our platform is accessible to all users, including those with disabilities. If you encounter accessibility issues while using our platform, please contact us at support@nexusstone.cloud. We will make reasonable efforts to address your concerns and improve our accessibility.</p>
                <h3>18. Refund Policy</h3>
                <p>Refunds are not generally provided for completed literature review services. However, if you experience a technical issue or believe that your service was not delivered as described, please contact us at support@nexusstone.cloud. Refund requests will be reviewed on a case-by-case basis, and any approved refunds will be processed in accordance with applicable laws.</p>
                <h3>19. Contact Us</h3>
                <p>If you have any questions or concerns about these Terms, please contact us at legal@nexusstone.cloud.</p>
            </div>
            <div className="divider-h"></div>
            </div>
            </div>
            </div>
            <Footer />
        </>
    )
}

export function Disclaimers() {
    return (
        <>
            <div id="main">
            <div id="home-container">
            <h2>Disclaimers</h2>
            <div id="home-animation">
            <div className="legal-container">
                <h3>1. AI Services</h3>
                <p>Lit Pro is a service provided by Nexus Stone Solutions. Our web application, Lit Pro ("we," "our," "us"), utilizes third-party services and Large Language Models (LLMs) to process text and generate literature reviews. While we strive for the highest quality and accuracy, the use of LLMs and AI services is subject to inherent limitations. Users acknowledge and accept that literature reviews generated by our platform may contain errors, including but not limited to:</p>
                <ul>
                <li>Incorrect authors or attribution.</li>
                <li>Incorrect publication dates.</li>
                <li>Incorrect or incomplete citation information.</li>
                <li>Incorrect citation formats.</li>
                <li>Missing information.</li>
                <li>Hallucinations (false or fabricated information).</li>
                </ul>
                <p>Users are solely responsible for proofreading and verifying the accuracy of any literature reviews or citations generated by our platform before using them in academic, professional, or other contexts. We disclaim any liability for damages resulting from reliance on inaccurate or incomplete content generated by our AI services.</p>
                <h3>2. Third-Party Services</h3>
                <p>We rely on third-party software and services, including open-source and proprietary solutions, to deliver our platform's features and functionalities. While we take reasonable measures to secure our application and your data, we do not have full control over the code or potential vulnerabilities within third-party software. To mitigate risks, we:</p>
                <ul>
                <li>Regularly scan for and address vulnerabilities.</li>
                <li>Apply security patches promptly as they become available.</li>
                </ul>
                <p>Despite these efforts, we cannot guarantee the absence of vulnerabilities in third-party services. By using our platform, you acknowledge and accept these inherent risks.</p>
                <h3>3. Limitations of Liability</h3>
                <p>To the fullest extent permitted by law, we shall not be held liable for any direct, indirect, incidental, special, or consequential damages resulting from:</p>
                <ul>
                <li>The use or inability to use our web application.</li>
                <li>Errors, inaccuracies, or omissions in content generated by AI services.</li>
                <li>Security vulnerabilities or breaches related to third-party services.</li>
                </ul>
                <h3>4. User Responsibilities</h3>
                <p>It is the user's responsibility to:</p>
                <ul>
                <li>Ensure compliance with all applicable laws and regulations when using our services.</li>
                <li>Verify the accuracy of any literature reviews or other content generated by our platform.</li>
                <li>Protect their account credentials and notify us immediately of any unauthorized access.</li>
                </ul>
                <h3>5. No Professional or Academic Advice</h3>
                <p>The literature reviews and other outputs generated by our platform are for informational purposes only and should not be considered professional or academic advice. Users are advised to consult appropriate experts or conduct independent verification where necessary.</p>
                <h3>6. Updates to Disclaimers</h3>
                <p>We reserve the right to update or modify these disclaimers at any time. Changes will be effective upon posting to our web application. Your continued use of the platform constitutes acceptance of the revised disclaimers.</p>
                <h3>7. Contact Us</h3>
                <p>For questions or concerns regarding these disclaimers, please contact us at legal@nexusstone.cloud.</p>
            </div>
            <div className="divider-h"></div>
            </div>
            </div>
            </div>
            <Footer />
        </>
    )
}

export function Playground() {
    return (
        <>
            <div id="main">
            <div style={{height: "120vh"}}>
            <h3 style={{textAlign: "center", backgroundColor: "#2c2c2ccc", padding: "20px"}}>Have fun with the background!</h3>
            </div>
            </div>
            <Footer />
        </>
    )
}